/**
 * External Dependencies
 */

// https://discourse.roots.io/t/sage-10-and-js-routing/19020

import LazyLoad from 'vanilla-lazyload';
import oldBrowser from './tools/old-browser';
import CookieBar from './tools/cookie-bar';
import ContactPopups from './components/popup-form';
import RatyCalculatorWrapper from './alpine-apps/raty-calculator';
import RatySingleCarCalculatorWrapper from './alpine-apps/raty-calculator-single-car.js';
import LaunchSplide from './alpine-apps/launch-splide';
import CountUpDirective from './alpine-directives/countup';
import LaunchLandingPage from "./alpine-apps/launch-landing-page";
import SelectedCars from "./alpine-apps/selected-cars";
import BlockCalcSale from './alpine-apps/block-calc-sale';
import BlockGallery from './alpine-apps/block-gallery';
import BlockGallerySlider from './alpine-apps/block-gallery-slider';
import './tools/responsive';
import './tools/scrollToSection';
import './helpers';
import './components/single-car-carousels';
import './components/brands-carousel';
import Alpine from 'alpinejs';
import AOS from 'aos';
import SingleCarCalculator from './components/single-car-calculator';
import searchCar from './components/searchCar';
import { compareFinanceMethods } from './components/compare-finances';
import { CompareCars } from './components/compare-cars';
import InstagramFeed from './components/instagram-feed';
import VideoPlayers from './components/video-player';
import './components/forms';
import { CF7_Checkbox, CF7_Field_Validator } from './components/forms';
import { RentAllInclusive } from './components/rent-all-inclusive';
import ContactMap from './components/contact-map';
import LeasingCarCalculator from './components/leasing-car-calculator';
import FormRules from './components/form-rules';
import Slider from './components/slider';
import TraitPoints from './components/trait-points';
import BodyPreference from './components/body-preference';
import PricingSerwis from './components/pricing-serwis';
import JSelect from 'jselect.js';
import JSelectCss from 'jselect.js/dist/select.js.css';

function formHandler()
{
  // checkboxes
    let acceptances = document.querySelectorAll('.js-acceptance');

    acceptances.forEach((acceptance) => {
        let checkbox = acceptance.querySelector('input');
        let fake_checkbox = acceptance.querySelector('.js-checkbox');

        let field = new CF7_Checkbox(acceptance, checkbox, fake_checkbox);
    });

    let checkboxes = document.querySelectorAll('.js-checkbox-parent');

    checkboxes.forEach((checkbox) => {
        let field = new CF7_Checkbox(
            checkbox,
            checkbox.querySelector('input'),
            checkbox.querySelector('.js-checkbox')
        );
    });

    let forms = document.querySelectorAll('.skoda-form');

    forms.forEach((form) => {
        new CF7_Field_Validator(form);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    formHandler();

  // Lazyload
    let lazyLoad = new LazyLoad({
        elements_selector: '[data-lazy]',
        load_delay: 300,
    });

    window.skodaLazyLoad = lazyLoad;

  // Alpine
    Alpine.directive('countup', CountUpDirective);
    Alpine.data('ratyCalculator', RatyCalculatorWrapper);
    Alpine.data('ratyCalculatorSingleCar', RatySingleCarCalculatorWrapper);
    Alpine.data('selectedCars', SelectedCars);
    Alpine.data('launchLandingPage', LaunchLandingPage);
    Alpine.data('launchSplide', LaunchSplide);
    Alpine.data('blockCalcSale', BlockCalcSale);
    Alpine.data('blockGallery', BlockGallery);
    Alpine.data('blockGallerySlider', BlockGallerySlider);
    window.Alpine = Alpine;
    Alpine.start();

  // AOS
    AOS.init();

  // Check Modern/Old Browser
    const checkBrowser = new oldBrowser();
    checkBrowser.init();

  // Cookiebar
    const _CookieBar = new CookieBar();
    _CookieBar.init();

    const _popup = new ContactPopups();
    _popup.init();
    _popup.animateLabels();
    _popup.pseudoDatcePickers();

    const _calculator = new SingleCarCalculator();
    _calculator.init();

  // footer menu
    const open_column_buttons = document.querySelectorAll('[data-open-column]');
    [...open_column_buttons].forEach((button) => {
        button.addEventListener('click', () => {
            button.nextSibling.classList.toggle('visible');
            button.classList.toggle('open');
        });
    });

  // archive for cars
    let _search = new searchCar(lazyLoad);
    _search.init();

    // Body preference cookie handler
    const _bodyPref = new BodyPreference();
    _bodyPref.init();

  // finances
    let _finances_compare = new compareFinanceMethods();
    _finances_compare.init();

  // rents
    let _rent_all_inclusive = new RentAllInclusive();
    _rent_all_inclusive.init();

    let _compare_cars = new CompareCars(lazyLoad);
    _compare_cars.init();

    let _instagramfeeds = new InstagramFeed();
    _instagramfeeds.init();

    let _formRules = new FormRules();
    _formRules.init();

    let _slider = new Slider();
    _slider.init();

    let _pricingSerwis = new PricingSerwis();
    _pricingSerwis.init();

    let _traitPoints = new TraitPoints();
    _traitPoints.init();

    const players = new VideoPlayers();

    const _contactMap = new ContactMap();
    _contactMap.init();
    function showMoreText()
    {
        let texts = document.querySelectorAll('.js-cf7 .more');

        console.log(texts);
        texts.forEach((text) => {
            let more_content = text.querySelector('.has-more');

            if (!more_content) {
                return;
            }

            let btn = document.createElement('BUTTON');
            btn.style.color = 'green';
            btn.innerHTML = 'Czytaj więcej';
            more_content.style.display = 'none';
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                btn.innerHTML =
                btn.innerHTML === 'Czytaj więcej' ? 'Ukryj ' : 'Czytaj więcej';
                more_content.style.display =
                more_content.style.display === 'none' ? 'inline' : 'none';
            });

        text.insertBefore(btn, more_content);
        });
    }

    showMoreText();

    let _leasingCalculator = new LeasingCarCalculator();
    _leasingCalculator.init();
});
